import { createStructuredSelector } from "reselect";

import { DEFAULT_SIGNUP_REQUIRED, DEFAULT_INVITE_REQUIRED } from "./constants";

import { getUserDetailSelector, getUserErrorSelector, UserState } from "../../ducks/user";
import { getPortalConfigSelector } from "../../ducks/portalConfig";

import { RootState } from "../../ducks/reducers";

const structuredSelectors = createStructuredSelector<
  RootState,
  Pick<UserState, "error"> & { detail?: string; required?: Record<string, boolean> }
>({
  error: getUserErrorSelector,
  detail: getUserDetailSelector,
  required: (state: RootState) => {
    const config = getPortalConfigSelector(state);
    const customRequired = config?.settings?.regForm?.required;

    if (customRequired) {
      return customRequired;
    }

    const signupByInvite = config?.settings?.signupByInvite ?? process.env.SIGNUP_BY_INVITE;

    return signupByInvite ? DEFAULT_INVITE_REQUIRED : DEFAULT_SIGNUP_REQUIRED;
  },
});

export default structuredSelectors;
